import React from 'react'
import { Box, Typography } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'

export interface ParticipantsPanelProps {
  participants: Array<{ id: string; name: string }>
  title: string
}

export const ParticipantsPanel: React.FC<ParticipantsPanelProps> = ({ participants, title }) => (
  <Box
    sx={{
      position: 'absolute',
      top: 16,
      right: 16,
      width: 240,
      maxHeight: 'calc(100% - 32px)',
      overflowY: 'auto',
      borderRadius: '12px',
      backgroundColor: 'rgba(15, 27, 46, 0.9)',
      border: `1px solid ${INTERAX_COLORS.white10}`,
      padding: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 1
    }}
  >
    <Typography
      sx={{
        fontSize: '14px',
        fontWeight: 600,
        color: INTERAX_COLORS.white,
        textTransform: 'uppercase',
        letterSpacing: '0.06em'
      }}
    >
      {title}
    </Typography>

    {participants.map((participant) => (
      <Box
        key={participant.id}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          padding: '8px 0',
          borderBottom: `1px solid ${INTERAX_COLORS.white04}`
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: INTERAX_COLORS.white10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 600,
            color: INTERAX_COLORS.white
          }}
        >
          {participant.name.substring(0, 2).toUpperCase()}
        </Box>
        <Typography sx={{ fontSize: '14px', fontWeight: 500, color: INTERAX_COLORS.white }}>
          {participant.name}
        </Typography>
      </Box>
    ))}
  </Box>
)
